import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
interface TermsOfServiceProps {
  onBack: () => void;
}
export function TermsOfService({
  onBack
}: TermsOfServiceProps) {
  const {
    language
  } = useLanguage();
  const content = {
    en: {
      title: 'Terms of Service',
      lastUpdated: 'Last Updated: January 2025',
      backToHome: 'Back to Home',
      sections: [{
        title: '1. Acceptance of Terms',
        content: `By accessing and using Coach Alex Fitness services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.`
      }, {
        title: '2. Services Description',
        content: `Coach Alex Fitness provides personal training services including:

• One-on-one personal training sessions
• Small group training sessions
• Online coaching programs
• Nutritional guidance and support

All services are subject to availability and may be modified at our discretion.`
      }, {
        title: '3. Health and Safety',
        content: `Before participating in any fitness program, you acknowledge that:

• You have consulted with a physician and are physically able to engage in exercise
• You will inform the trainer of any health conditions, injuries, or limitations
• You understand that physical exercise carries inherent risks
• You agree to follow all safety instructions provided by the trainer

You are responsible for your own health and safety during training sessions.`
      }, {
        title: '4. Booking and Cancellation',
        content: `Session Booking:
• Sessions must be booked at least 24 hours in advance
• Bookings are confirmed upon receipt of payment or confirmation

Cancellation Policy:
• Cancellations made 24+ hours before the session: Full refund or reschedule
• Cancellations made less than 24 hours before: No refund
• No-shows: Session will be forfeited

We reserve the right to cancel or reschedule sessions with reasonable notice.`
      }, {
        title: '5. Payment Terms',
        content: `• Payment is due at the time of booking or as agreed upon
• All prices are listed in the local currency and are subject to change
• Package deals and memberships are non-transferable
• Refunds are provided only in accordance with our cancellation policy`
      }, {
        title: '6. Code of Conduct',
        content: `All clients are expected to:

• Arrive on time for scheduled sessions
• Wear appropriate workout attire
• Treat trainers and other clients with respect
• Follow gym rules and regulations
• Refrain from using offensive language or behavior

We reserve the right to terminate services for violations of this code.`
      }, {
        title: '7. Intellectual Property',
        content: `All training programs, workout plans, and materials provided are the intellectual property of Coach Alex Fitness. You may not:

• Reproduce or distribute our materials without permission
• Share online coaching content with non-paying individuals
• Use our branding or content for commercial purposes`
      }, {
        title: '8. Limitation of Liability',
        content: `Coach Alex Fitness shall not be liable for:

• Any injuries sustained during training (except due to gross negligence)
• Loss or damage to personal belongings
• Results that do not meet your expectations
• Technical issues with online coaching platforms

Our total liability is limited to the amount paid for services.`
      }, {
        title: '9. Changes to Terms',
        content: `We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting. Continued use of our services constitutes acceptance of modified terms.`
      }, {
        title: '10. Contact Information',
        content: `For questions about these Terms of Service, please contact us:

Email: Example@email.com
Phone: (555) 123-4567
Address: Iron District Gym, 123 Fitness Blvd, Los Angeles, CA`
      }]
    },
    pl: {
      title: 'Regulamin',
      lastUpdated: 'Ostatnia aktualizacja: Styczeń 2025',
      backToHome: 'Powrót do strony głównej',
      sections: [{
        title: '1. Akceptacja warunków',
        content: `Korzystając z usług Coach Alex Fitness, zgadzasz się przestrzegać niniejszego Regulaminu. Jeśli nie zgadzasz się z tymi warunkami, prosimy o niekorzystanie z naszych usług.`
      }, {
        title: '2. Opis usług',
        content: `Coach Alex Fitness świadczy usługi treningu personalnego, w tym:

• Indywidualne sesje treningowe
• Treningi w małych grupach
• Programy coachingu online
• Wsparcie i porady żywieniowe

Wszystkie usługi podlegają dostępności i mogą być modyfikowane według naszego uznania.`
      }, {
        title: '3. Zdrowie i bezpieczeństwo',
        content: `Przed przystąpieniem do jakiegokolwiek programu fitness, potwierdzasz, że:

• Skonsultowałeś się z lekarzem i jesteś zdolny fizycznie do ćwiczeń
• Poinformujesz trenera o wszelkich schorzeniach, kontuzjach lub ograniczeniach
• Rozumiesz, że ćwiczenia fizyczne wiążą się z nieodłącznym ryzykiem
• Zgadzasz się przestrzegać wszystkich instrukcji bezpieczeństwa

Jesteś odpowiedzialny za własne zdrowie i bezpieczeństwo podczas sesji treningowych.`
      }, {
        title: '4. Rezerwacje i anulowanie',
        content: `Rezerwacja sesji:
• Sesje należy rezerwować z co najmniej 24-godzinnym wyprzedzeniem
• Rezerwacje są potwierdzane po otrzymaniu płatności lub potwierdzenia

Polityka anulowania:
• Anulowanie 24+ godzin przed sesją: Pełny zwrot lub przełożenie
• Anulowanie mniej niż 24 godziny przed: Brak zwrotu
• Niestawienie się: Sesja przepada

Zastrzegamy sobie prawo do anulowania lub przełożenia sesji z odpowiednim wyprzedzeniem.`
      }, {
        title: '5. Warunki płatności',
        content: `• Płatność jest wymagana w momencie rezerwacji lub zgodnie z ustaleniami
• Wszystkie ceny są podane w lokalnej walucie i mogą ulec zmianie
• Pakiety i członkostwa są niezbywalne
• Zwroty są dokonywane wyłącznie zgodnie z naszą polityką anulowania`
      }, {
        title: '6. Kodeks postępowania',
        content: `Od wszystkich klientów oczekuje się:

• Punktualnego przybycia na zaplanowane sesje
• Noszenia odpowiedniego stroju sportowego
• Traktowania trenerów i innych klientów z szacunkiem
• Przestrzegania zasad i regulaminu siłowni
• Powstrzymania się od obraźliwego języka lub zachowania

Zastrzegamy sobie prawo do zakończenia świadczenia usług w przypadku naruszenia tego kodeksu.`
      }, {
        title: '7. Własność intelektualna',
        content: `Wszystkie programy treningowe, plany ćwiczeń i materiały są własnością intelektualną Coach Alex Fitness. Nie możesz:

• Reprodukować ani rozpowszechniać naszych materiałów bez zgody
• Udostępniać treści coachingu online osobom niepłacącym
• Używać naszej marki lub treści w celach komercyjnych`
      }, {
        title: '8. Ograniczenie odpowiedzialności',
        content: `Coach Alex Fitness nie ponosi odpowiedzialności za:

• Kontuzje odniesione podczas treningu (z wyjątkiem rażącego zaniedbania)
• Utratę lub uszkodzenie rzeczy osobistych
• Wyniki niespełniające Twoich oczekiwań
• Problemy techniczne z platformami coachingu online

Nasza całkowita odpowiedzialność jest ograniczona do kwoty zapłaconej za usługi.`
      }, {
        title: '9. Zmiany w regulaminie',
        content: `Zastrzegamy sobie prawo do modyfikacji niniejszego Regulaminu w dowolnym momencie. Zmiany wchodzą w życie natychmiast po opublikowaniu. Dalsze korzystanie z naszych usług oznacza akceptację zmienionych warunków.`
      }, {
        title: '10. Dane kontaktowe',
        content: `W przypadku pytań dotyczących niniejszego Regulaminu, prosimy o kontakt:

Email: Example@email.com
Telefon: +48 123 456 789
Adres: Iron District Gym, ul. Fitness 123, Warszawa`
      }]
    }
  };
  const t = content[language];
  return <div className="min-h-screen bg-brand-dark pt-24 pb-16 px-4" data-id="element-163">
      <div className="max-w-4xl mx-auto" data-id="element-164">
        <button onClick={onBack} className="flex items-center gap-2 text-brand-accent hover:text-brand-accentHover transition-colors mb-8 group" data-id="element-165">
          <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" data-id="element-166" />
          <span className="font-bold uppercase tracking-wider text-sm" data-id="element-167">
            {t.backToHome}
          </span>
        </button>

        <h1 className="font-display text-5xl md:text-6xl text-white mb-4" data-id="element-168">
          {t.title}
        </h1>
        <p className="text-gray-500 mb-12" data-id="element-169">{t.lastUpdated}</p>

        <div className="space-y-10" data-id="element-170">
          {t.sections.map((section, index) => <div key={index} className="border-l-2 border-brand-accent/30 pl-6" data-id="element-171">
              <h2 className="font-display text-2xl text-white mb-4" data-id="element-172">
                {section.title}
              </h2>
              <p className="text-gray-400 leading-relaxed whitespace-pre-line" data-id="element-173">
                {section.content}
              </p>
            </div>)}
        </div>
      </div>
    </div>;
}